export default __webpack_public_path__ + "static/mask_face_1-fa7578e70688843900efbb9ec45b9158.svg";